<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
            <div class="topImgTitle">我的诉求</div>
            <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
            <div class="e-flex menuContent">
                <img class="ic_home" src="@/assets/images/ic_home.png">
                <div class="pointer" @click="goMainPage()">首页</div>
                <div>/</div>
                <div>企业人才诉求表单</div>
                </div>
            </div>
        </div>
        <div class="af_allContent e-flex">
            <div class="af_formWhite">
                <div class="af_formTitle">企业建言和诉求采集事项</div>
                <div class="af_formEleContent">
                    <div class="e-flex af_formEle">
                        <div class="af_label">
                            <span>*</span>
                            企业名称
                        </div>
                        <div class="af_value af_value1 e-flex">
                            <el-input v-model="appealForm.company" placeholder="请填写企业名称"></el-input>
                        </div>
                    </div>
                    <div class="e-flex af_formEle">
                        <div class="af_label">
                            <span>*</span>
                            企业地址
                        </div>
                        <div class="af_value af_value1 e-flex">
                            <el-input v-model="appealForm.address" placeholder="请填写企业地址"></el-input>
                        </div>
                    </div>
                    <div class="e-flex af_formEle">
                        <div class="af_label">
                            <span>*</span>
                            联系人
                        </div>
                        <div class="af_value af_value1 e-flex">
                            <el-input v-model="appealForm.contact" placeholder="请填写联系人"></el-input>
                        </div>
                    </div>
                    <div class="e-flex af_formEle">
                        <div class="af_label">
                            <span>*</span>
                            联系方式
                        </div>
                        <div class="af_value af_value1 e-flex">
                            <el-input v-model="appealForm.phone" placeholder="请填写联系方式"></el-input>
                        </div>
                    </div>
                    <div class="e-flex af_formEle af_formEle2">
                        <div class="af_label">
                            <span>*</span>
                            诉求事项
                        </div>
                        <div class="af_value af_value2 e-flex">
                            <el-input type="textarea" v-model="appealForm.content" :rows="3" placeholder="请填写诉求事项"></el-input>
                        </div>
                    </div>
                    <div class="e-flex af_formEle af_formEle2">
                        <div class="af_label">意见或建议</div>
                        <div class="af_value af_value2 e-flex">
                            <el-input type="textarea" v-model="appealForm.feed" :rows="3" placeholder="请填写意见或建议"></el-input>
                        </div>
                    </div>
                </div>
                <div class="af_saveBtn" @click="submitData()">提交</div>
            </div>
        </div>
        <div class="af_allContent e-flex">
            <div class="af_questionWhite">
                <div class="af_questionTitle">热门问题</div>
                <div class="af_questionContent">
                    <div class="e-flex af_questionTop">
                        <div class="af_questionQ">Q.</div>
                        <div class="af_questionListTitle e-line-1">中关村国家自主创新示范区促进科技金融深度融合发展支持资金管理办法?</div>
                    </div>
                    <div class="af_questionBottom e-line-1">支持投资机构在我市设立私募股权投资基金，鼓励投资机构积极募集长期资金支持投资机构在我市设立私募股权投资基金。</div>
                </div>
                <div class="af_questionContent">
                    <div class="e-flex af_questionTop">
                        <div class="af_questionQ">Q.</div>
                        <div class="af_questionListTitle e-line-1">中关村国家自主创新示范区促进科技金融深度融合发展支持资金管理办法?</div>
                    </div>
                    <div class="af_questionBottom e-line-1">支持投资机构在我市设立私募股权投资基金，鼓励投资机构积极募集长期资金支持投资机构在我市设立私募股权投资基金。</div>
                </div>
                <div class="af_viewMore e-flex">查看更多<i class="el-icon-d-arrow-right"></i></div>
            </div>
        </div>
        
        <div class="ad_bottom"></div>
      
    </div>
  </template>
  
  <script>
    import '../../styles/appeal.css'
    export default {
      name: 'appealForm',
      data () {
        return {
          from: '',
          appealForm: {
            company: '',
            address: '',
            contact: '',
            phone: '',
            content: '',
            feed: '',
            user: {},
          }
        }
      },
      created() {
        this.user = JSON.parse(localStorage.getItem('user'))
        this.from = this.$route.query.from
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        submitData() {
            console.log(this.appealForm)
            // if (this.appealForm.company == '' || this.appealForm.address == '' || this.appealForm.contact == '' || this.appealForm.content == '' || this.appealForm.phone == '') {
            //     this.$message({
            //         message: '请完善表单',
            //         type: 'warning',
            //     });
            //     return
            // }
            this.$confirm('确认提交当前诉求?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let param = this.appealForm
                console.log(this.user)
                param.userId = this.user.id ? this.user.id : this.user.data.id
                console.log(param)
                this.request({
                    url: 'feedback/add',
                    method: 'POST',
                    data: param
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message: '诉求上传成功',
                            type: 'success',
                        });
                        setTimeout(() => {
                            this.$router.push({ path: '/appeal/index', query: {}})
                        },1000)
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        });
                    }
                })
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                        
            });
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/appeal/appealForm.vue